import { PriceAgreementRule } from './price-agreement-rule';

export enum SubjectType {
  Customer = 0,
  Project = 1
}

export enum PriceAgreementState {
  Scheduled = 0,
  Active = 1,
  Expired = 2,
  Blocked = 3
}

export interface PriceAgreement {
  id: number;
  subject_type: SubjectType;
  subject_id: number;
  description: string;
  valid_from: string;
  valid_to: string | null;
  blocked: boolean;
  rules: PriceAgreementRule[];
}
